<template>
    <div class="feedback-section" v-if="feedbackData.length > 0">
        <div class="container">
            <div class="title">
                <h3>
                    Saiba o que estão falando sobre a plataforma
                </h3>
            </div>

            <div class="feedback-cards">
                <b-carousel
                    id="carousel-1"
                    v-model="slide"
                    :interval="10000"
                    controls
                    indicators
                    :background="getIsDarkTheme ? '#000' : '#fff'"
                    img-width="1024"
                    img-height="480"
                    style="text-shadow: 1px 1px 2px #333;"
                    @sliding-start="onSlideStart"
                    @sliding-end="onSlideEnd"
                >
                    <b-carousel-slide img-blank v-for="(item, index) in feedbackData" :key="index">
                        <div class="cards">
                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <div class="card left">
                                        <div class="text">
                                            {{ item.texto }}
                                        </div>

                                        <div class="person">
                                            <div class="img">
                                                <img :src="feedbackCards" alt="person-image" v-if="feedbackCards" />
                                            </div>

                                            <div class="person-data">
                                                <div class="name">
                                                    {{ item.nome }}
                                                </div>

                                                <div class="company">
                                                    {{ item.profissao }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-12 col-md-6">
                                    <div class="card right">
                                        <div class="text">
                                            {{ item[1].texto }}
                                        </div>

                                        <div class="person">
                                            <div class="img">
                                                <img :src="feedbackCards" alt="person-image" v-if="feedbackCards" />
                                            </div>

                                            <div class="person-data">
                                                <div class="name">
                                                    {{ item[1].nome }}
                                                </div>

                                                <div class="company">
                                                    {{ item[1].profissao }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </b-carousel-slide>
                </b-carousel>
            </div>
        </div>
    </div>
</template>

<script>
import { LandingPageApi } from '../../../../../api/landing-page-api'

const landingPageApi = new LandingPageApi()

export default {
    name: 'FeedbackSection',
    data() {
        return {
            slide: 0,
            feedbackData: null,
            sliding: null,
            feedbackCards: require('@/assets/perfil-default.png')
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
        fetch() {
            landingPageApi.getHomeData().then(response => {
                this.feedbackData = response.data.data.depoemento
            })
        }
    },
    created() {
        this.fetch()
    }
}
</script>

<style scope src="./FeedbackSection-light-theme.css"></style>
<style scope src="./FeedbackSection-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/components/landing-page/feedback-section/FeedbackSection.vue